import type { HeaderTitle } from '@/lib/header-action-context';
import { cn } from '@/lib/utils';

export function PageTitle({ icon, title, subtitle, badges, intense }: HeaderTitle) {
    const hasTitle = Boolean(title?.trim());
    const hasSubtitle = Boolean(subtitle?.trim());
    if (!icon && !hasTitle && !hasSubtitle && !badges) {
        return null;
    }

    return (
        <div data-slot="page-title" className="flex min-w-0 items-center gap-2.5">
            {icon && (
                <div
                    className={cn(
                        'shrink-0',
                        intense &&
                            'rounded-md shadow-[0_2px_14px_rgba(15,23,42,0.22)] [filter:saturate(1.35)_contrast(1.08)]',
                    )}
                >
                    {icon}
                </div>
            )}
            <div className="min-w-0">
                {(hasTitle || badges) && (
                    <div className="flex min-w-0 items-center gap-2">
                        {hasTitle ? (
                            <h1 className="shrink-0 pr-3 text-xl font-semibold leading-tight text-[hsl(var(--page-header-foreground))]">
                                {title}
                            </h1>
                        ) : null}
                        {badges}
                    </div>
                )}
                {hasSubtitle && (
                    <p className="truncate font-mono text-xs leading-snug text-[hsl(var(--page-header-muted-foreground))]">
                        {subtitle}
                    </p>
                )}
            </div>
        </div>
    );
}
